<template>
  <div class="plat-form-wrap">
    <div class="slides-wrap">
      <a-carousel arrows>
        <div
          class="dot-item"
          :style="{ backgroundImage: `url(${bgImg})` }"
        ></div>
      </a-carousel>
    </div>
    <div class="body-wrap home-mini-width">
      <a-row>
        <a-col :span="24">
          <div class="infos">
            <TitleCard
              title="资源检索"
              :type="'firstCard'"
              :showMore="false"
              @moreClick="toRouter('searchMore')"
            >
              <template>
                <div class="searchCard" style="margin-bottom:60px">
                  <Search class="search"></Search>
                </div>
              </template>
            </TitleCard>
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="newBck">
      <div class="body-wrap home-mini-width ">
        <a-row>
          <a-col :span="24">
            <div class="infos">
              <TitleCard
                title="新闻资讯"
                :loading="loading1"
                :isEmpty="isEmpty1"
                :type="'firstCard'"
                @moreClick="toRouter('generalInfo', { type: 'infos' })"
              >
                <template>
                  <ListImg
                    ref="infos1"
                    :result="infos1"
                    @handleDetail="toDetail"
                  ></ListImg>
                </template>
              </TitleCard>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="body-wrap home-mini-width">
      <a-row>
        <a-col :span="24">
          <div class="infos">
            <TitleCard
              title="战略产业"
              :loading="StrategicLoading"
              :isEmpty="StrategicEmpty"
              :type="'firstCard'"
              @moreClick="toRouter('dealInfos')"
              :isTabs="true"
              :tabList="tabList"
              @selectTab="selectTab"
              :selectedIndx="selectedIndx"
            >
              <div class="searchCard">
                <div class="sIndustry">
                  <div class="result-card-wrap">
                    <a-row :gutter="[16, 16]" type="flex">
                      <a-col
                        class="col"
                        v-for="colItem in info1"
                        :key="colItem.id"
                        :span="6"
                      >
                        <ResultCard :instance="colItem"></ResultCard>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </div>
            </TitleCard>
            <!-- <TalentInfo :title="'技术团队'"></TalentInfo> -->
          </div>
        </a-col>
      </a-row>
    </div>
    <div class="marketBck">
      <div class="body-wrap home-mini-width">
        <a-row>
          <a-col :span="24">
            <div class="infos">
              <MarketDemand></MarketDemand>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import ListImg from './components/ListImg'
import ResultCard from '@/components/common/ResultCard'
// import TalentInfo from './components/talentList'
import MarketDemand from '@/views/MPlatformPortal/components/MarketDemand'
const industryList = require('@/utils/industryList')
import {
  getIndustryInfo,
  getTradingInfo,
  getDemandsInfo,
  getTransInfo
} from '@/api/tradingInfos.js'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { ipView } from '@/api/systemUser'
import { viewResultInfo } from '@/api/tradingInfos'
import Search from '../Home/components/Search'
export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      bgImg: require('@/assets/images/zQImg/首页banner.png'),
      position: 'bottom',
      loading1: false,
      isEmpty1: false,
      infos1: {},
      infos2: {},
      loading2: false,
      isEmpty2: false,
      infos3: {},
      loading3: false,
      isEmpty3: false,
      noticeList: [], // 通告
      loading4: false,
      isEmpty4: false,
      params: {
        pageSize: 8,
        pageNum: 1
      },
      loadingNew: false,
      isEmptyNew: false,
      tableList: [],
      tabList: industryList.industryLists,
      selectedIndx: 0,
      info1: [], // 战略
      StrategicLoading: false,
      StrategicEmpty: false,
      selectVal: industryList.industryLists[0]
    }
  },
  components: {
    ListImg,
    Search,
    MarketDemand,
    ResultCard
  },
  computed: {
    ...mapGetters('user', ['visitor'])
  },
  mounted() {
    let key = process.env.VUE_APP_KEY
    switch (key) {
      case 'foShan': // 佛山
        this.bgImg = require('@/assets/images/foShanImg/banner.png')
        break
      case 'Hy': // 河源
        this.bgImg = require('@/assets/images/HyImg/首页banner.png')
        break
      case 'Mm': //茂名
        this.bgImg = require('@/assets/images/MmImg/首页banner.png')
        break
      case 'Yj': //阳江
        this.bgImg = require('@/assets/images/YjImg/首页banner.png')
        break
      case 'Mz': //梅州
        this.bgImg = require('@/assets/images/MzImg/首页banner.png')
        break
      case 'SzTech': //深圳市新材料产业知识产权运营公共服务平台
        this.bgImg = require('@/assets/images/SzTech/banner.png')
        break
    }

    this.initSetting()
  },
  methods: {
    ...mapMutations('headerMenu', ['updateMenuItemStatus']),
    initSetting() {
      this.initIndustryInfo()
      this.initResultInfo()
      this.initDemandInfo()
      this.initTransInfo()
      this.getIp()
    },
    // tab切换
    selectTab(val) {
      this.selectedIndx = val.index
      this.selectVal = val.tab
      this.initResultInfo(val.tab.key)
    },
    loadChange(val) {
      this.loadingNew = val.loading
      this.isEmptyNew = val.isEmpty
    },
    getIp() {
      // eslint-disable-next-line no-undef
      let ip = returnCitySN['cip']
      ipView(ip).then()
    },
    collectImg(instance, initPath) {
      if (!instance) return []
      return instance.reduce((pre, cur) => {
        const fileVo = cur.fileVo
        if (!fileVo || fileVo.length === 0) {
          // pre.push('/static/noImg.png')
          return pre
        }
        const v = fileVo[0].filePath || initPath
        pre.push(v)
        return pre
      }, [])
    },
    async initIndustryInfo() {
      this.loading1 = true
      const { rows } = await getIndustryInfo(1)
      const row = this.handlerDateFormat(rows)
      const infosImg = this.collectImg(row, '/static/index1.png')
      const industryList = {
        infosImg,
        list: row
      }
      console.log(industryList)
      this.infos1 = industryList
      this.isEmpty1 = rows.length === 0
      this.loading1 = false
    },
    async initResultInfo(val) {
      let obj = {
        industry: '1'
      }
      if (val) {
        obj.industry = val
      }
      try {
        this.StrategicLoading = true
        const { data } = await getTradingInfo(this.params, obj)
        this.info1 = data.rows
        this.StrategicEmpty = data.total === 0
        this.StrategicLoading = false
      } catch (error) {
        this.$apiStatusHandler(99, error)
      }
    },
    async initDemandInfo() {
      this.loading3 = true
      const { data } = await getDemandsInfo(this.params, {})
      this.handlerDateFormat(data.rows)
      const DemandList = {
        infosImg: '/static/index3.png',
        list: data.rows
      }
      this.infos3 = DemandList
      this.isEmpty3 = data.rows.length === 0
      this.loading3 = false
    },
    async initTransInfo() {
      this.loading4 = true
      const { rows } = await getTransInfo()
      this.loading4 = false
      this.isEmpty4 = rows.length === 0
      if (rows.length >= 5) {
        this.noticeList = rows.slice(0, 4)
        return
      }
      this.noticeList = rows
    },
    toDetail(id) {
      this.$router.push({ name: 'generalInfoDetails', query: { id } })
    },
    toDetail1(id) {
      viewResultInfo(id).then()
      this.$router.push({ name: 'detailDeal', query: { id } })
    },
    toDetail2(id) {
      viewResultInfo(id).then()
      this.$router.push({ name: 'detailDemand', query: { id } })
    },
    toDetail3(id) {
      this.$router.push({ name: 'detailAnnouncement', query: { id } })
    },
    toRouter(router, params) {
      if (router === 'dealInfos') {
        let obj = {
          fatherTag: '产业分类',
          childTagItem: industryList.industryLists[0],
          checked: true,
          instance: {
            isMore: false,
            hasMore: false,
            moreTitle: '展开',
            name: '产业分类',
            prop: 'industry',
            icon: '/static/cpfl.png',
            tagList: industryList.industryLists,
            spliceIdx: -1
          }
        }
        obj.childTagItem = this.selectVal
        params = JSON.stringify(obj)
        this.$router.push({
          name: router,
          params: { selectVal: params }
        })
      } else {
        this.$router.push({ name: router, query: { ...params } })
      }
    }
  }
}
</script>
